import PropTypes from "prop-types";
import React, { PureComponent } from "react";
import { uploadStudentProof } from "../api/registrationInfo";
import { toast } from "react-toastify";

export default class ProofOfStudiesUpload extends PureComponent {
    static propTypes = {
        onUploaded: PropTypes.func.isRequired,
        enabled: PropTypes.bool,
    };

    componentDidMount = () => {}

    _uploadStudentProof = e => {
        e.preventDefault();
        uploadStudentProof(e.target.files[0])
            .then(response => {
                this.props.onUploaded();
                toast.success("Student proof of studies uploaded");

            })
    }

    _triggerFileUpload = e => {
        e.preventDefault();
        this.fileInput.click();
    }

    render() {
        return (
            <React.Fragment>
				<input 
	                ref={fileInput => this.fileInput = fileInput} 
	                type="file"
	                className="proof-of-studies"
	                onChange={e => this._uploadStudentProof(e)}
	             />
	            <button className="btn btn-primary btn-block" disabled={!this.props.enabled} onClick={e => this._triggerFileUpload(e)}>Submit Proof of Studies</button>
            </React.Fragment>
        );
    }
}